/**
 * AI Assistant Invariants
 *
 * Minimal invariants - all sources are allowed.
 */

import { Invariants } from '@commandDrivenStateEngine/core/invariants';
import { AIAssistantState } from './state';
import { AIAssistantCommand } from './commands';

export const invariants: Invariants<AIAssistantState, AIAssistantCommand> = {
  normalize: undefined,
  canApply: () => true,
  validate: () => null
};
